module.exports = __webpack_public_path__ + "static/img/ks_kegy.506b1d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ks_kegy.png
// module id = 2gLK
// module chunks = 130